(() => {
  class ProductPrice extends HTMLElement {
    connectedCallback() {
      this.priceElement = this.querySelector('[data-product-price]');
      this.currentPrice = this.querySelector('[data-product-current-price]');
      this.comparePrice = this.querySelector('[data-product-compare-price]');
      this.unitPrice = this.querySelector('[data-product-unit-price]');
      this.unitPriceValue = this.querySelector('[data-product-unit-price-value]');
      this.onVariantChange = this.onVariantChange.bind(this);

      document.addEventListener('product:variant-change', this.onVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('product:variant-change', this.onVariantChange);
    }

    onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      const eventScope = event.detail && event.detail.scope;

      if (!variant || !this.priceElement || !this.currentPrice || !this.comparePrice) return;
      if ((eventScope || this.scope) && eventScope !== this.scope) return;

      const isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      this.currentPrice.textContent = variant.price_text;
      this.comparePrice.hidden = !isOnSale;

      if (isOnSale) {
        this.comparePrice.textContent = variant.compare_at_price_text;
      }

      if (this.unitPrice && this.unitPriceValue) {
        this.unitPrice.hidden = !variant.unit_price_text;
        this.unitPriceValue.textContent = variant.unit_price_text || '';
      }
    }

    get scope() {
      return this.dataset.productUiScope || this.closest('.product-layout, .featured-product-showcase, [data-search-product-drawer]') || '';
    }
  }

  if (!customElements.get('product-price')) {
    customElements.define('product-price', ProductPrice);
  }
})();
